<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Warning
      </div>
      <button
        class="ac-close-button"
        type="button"
        @click="toggleActionModal(false)"
      >
        <img
          src="../../../assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div>Are you sure you want to delete the payment method</div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        type="button"
        @click="cancel"
      >
        <span class="warning-settings">
          Cancel
        </span>
      </button>
      <button
        class="ac-form-deactivate"
        type="button"
        @click="remove"
      >
        <span class="warning-settings">
          Delete
        </span>
      </button>
    </div>
    <ProcessOverlay
      :show="processing"
    />
  </div>
</template>
<script>
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'DeletePaymentWarning',
  components: {
    ProcessOverlay,
  },
  props: {
    corpId: Number,
    firstName: String,
    lastName: String,
    toEmail: String,
    partnerSettings: Object,
    changes: Function,
    toggleActionModal: Function,
    onSubmit: Function,
  },
  data() {
    return {
      processing: false,
    };
  },
  methods: {
    cancel() {
      this.toggleActionModal(false);
    },
    async remove() {
      this.processing = true;
      try {
        await this.$store.dispatch('removeBillingPaymentMethod');
        this.toggleActionModal(false);
      } catch (err) {
        console.error(err);
      }
      this.processing = false;
    },
  },
};
</script>

<style lang="scss">

.warning-settings {
  color: white;
  font-size: 14px;
  font-weight: bold;
}
</style>
